import logo from './logo-inovacao.png'
import axios from "axios";

import Navbar from './Navbar'
import Topbar from './Topbar'

import {useState, useEffect} from 'react'
import { Link, useNavigate } from 'react-router-dom';
import {APIURL} from './config'
import Loading from './Loading'

function Home() {

    const [results, setResults] = useState()

    const navigate = useNavigate()

    useEffect(() => {
        if (!sessionStorage.getItem("tokeninovacao")) {
            navigate('/login')
        }
        listresume( sessionStorage.getItem("tokeninovacao"))
    }, [])

    const listresume= async (mytoken) => {
        
        try {
            const res = await axios.post(`${APIURL}/Inovation/Stats/`, {TOKEN : mytoken});
            if (res.data) {
                setResults(res.data);
            }
        } catch (err) {
            alert("Ocorreu um erro. Tente novamente.");
        }
    }  

    return (

        <div >
           <Topbar />

                {results ?
                    <div className="container py-4 px-2 px-md-5">
                        <div className="h4 py-4">Olá, Pedro</div>

                        <div className="row g-3 mb-3">
                            <div className="col-12 col-md-4">
                                <div className="card rounded-3 shadow-sm p-3 h-100">
                                <div className="d-flex align-items-center gap-3">
                                    <div className="round-badge  rounded-circle d-flex align-items-center justify-content-center">
                                    <i className="bi bi-lightbulb fs-3"></i>
                                    </div>
                                    <div>
                                    <div className="h6 text-muted fw-normal mb-1">IDEIAS SUGERIDAS</div>
                                    <div className="h1 fw-bolder mb-0">{results.Qty_Innovations}</div>
                                    </div>
                                </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="card rounded-3 shadow-sm p-3 h-100">
                                <div className="d-flex align-items-center gap-3">
                                    <div className="round-badge  rounded-circle d-flex align-items-center justify-content-center">
                                    <i className="bi bi-check fs-3"></i>
                                    </div>
                                    <div>
                                    <div className="h6 text-muted fw-normal mb-1">IDEIAS APROVADAS</div>
                                    <div className="h1 fw-bolder mb-0">{results.Qty_Innovations_Approved}</div>
                                    </div>
                                </div>
                                </div>
                            </div>

                            <div className="col-12 col-md-4">
                                <div className="card rounded-3 shadow-sm p-3 h-100">
                                <div className="d-flex align-items-center gap-3">
                                    <div className="round-badge  rounded-circle d-flex align-items-center justify-content-center">
                                    <i className="bi bi-megaphone fs-3"></i>
                                    </div>
                                    <div>
                                    <div className="h6 text-muted fw-normal mb-1">CAMPANHAS ENGAJADAS</div>
                                    <div className="h1 fw-bolder mb-0">{results.Qty_Campaings_Active}</div>
                                    </div>
                                </div>
                                </div>
                            </div>
                        </div>



                        <div className="round-badge bg-warning rounded-circle d-flex align-items-center justify-content-center" style={{marginRight: 30,position: 'absolute', right:40,  bottom: 40, }}>
                            <Link to="/novaideia"> <i className="bi bi-plus fs-3 fw-bold text-white"></i></Link>
                        </div>
                    
                    </div>
                        // <div classNameName="row" >
                        //     <div classNameName="col-lg-4">
                        //         <div classNameName="widget style1 navy-bg">
                        //                 <div classNameName="row">
                        //                     <div classNameName="col-xs-4 text-center">
                        //                         <i classNameName="fa fa-lightbulb-o fa-5x"></i>
                        //                     </div>
                        //                     <div classNameName="col-xs-8 text-right">
                        //                         <span> IDEIAS OFERECIDAS </span>
                        //                         <h2 classNameName="font-bold">{results.Qty_Innovations}</h2>
                        //                     </div>
                        //                 </div>
                        //         </div>
                        //     </div>
                        //     <div classNameName="col-lg-4">
                        //         <div classNameName="widget style1 navy-bg">
                        //             <div classNameName="row">
                        //                 <div classNameName="col-xs-4">
                        //                     <i classNameName="fa fa-check-circle fa-5x"></i>
                        //                 </div>
                        //                 <div classNameName="col-xs-8 text-right">
                        //                     <span> IDEIAS APROVADAS </span>
                        //                     <h2 classNameName="font-bold">{results.Qty_Innovations_Approved}</h2>
                        //                 </div>
                        //             </div>
                        //         </div>
                        //     </div>
                        //     <div classNameName="col-lg-4">
                        //         <div classNameName="widget style1 navy-bg">
                        //             <div classNameName="row">
                        //                 <div classNameName="col-xs-4">
                        //                     <i classNameName="fa fa-group fa-5x"></i>
                        //                 </div>
                        //                 <div classNameName="col-xs-8 text-right">
                        //                     <span> CAMPANHAS ENGAJADAS </span>
                        //                     <h2 classNameName="font-bold">{results.Qty_Campaings_Active}</h2>
                        //                 </div>
                        //             </div>
                        //         </div>
                        //     </div>
                        // </div>
                    

                    






                
                :
                    <Loading />
                }
            </div>


            
        
            

       
      );
    }
    
    export default Home;
